<template>
  <div class="main-wrap">
    <full-page
      :options="fullpageOpt"
      ref="fullpage"
      class="fullpage-wrapper"
      id="fullpage"
    >
      <div class="section s2">
        <main-line />
        <div class="section-content">
          <img src="../assets/main-logo.svg" alt class="logo" />
          <!-- <p v-if='showNoti'>이제 <a href="https://sellery.me">sellery.me</a> 로 접속하실 수 있습니다! <a class='close' @click='closeNoti'>그만 보기</a></p> -->
        </div>
        <div class="nav-wrap bottom" v-show="!isFullPageMoving">
          <div class="nav gray"></div>
        </div>
      </div>
      <div class="section s3">
        <!-- 실제 보이는 영역 -->
        <div class="section-content">
          <div class="input-wrap center">
            <div class="main-data">
              나는
              <input
                type="number"
                @input="setInputDate"
                min="1"
                :max="maxDate"
                v-model="inputValue.date"
                :style="{ width: inputWidth.date + 'px' }"
                placeholder="급여일"
              />일에
              <br />
              <input
                type="text"
                pattern="[0-9]+([,\.][0-9]+)?"
                @input="setInputPay"
                min="1"
                v-model="inputValue.pay"
                :style="{ width: inputWidth.pay + 'px' }"
                placeholder="월급 실수령액"
              />
              원 받는다.
              <button
                class="more"
                :class="{ minus: isMore }"
                @click="isMore = !isMore"
              />
            </div>
            <div class="more-data" :class="{ open: isMore }">
              <div class="work-day">
                매 주
                <span
                  :class="{ active: worksDays.indexOf(i - 1) > -1 }"
                  v-for="i in 7"
                  :key="i"
                  :day-val="i - 1"
                  @click="dayClicked"
                  >{{ weekdayNameList[i - 1] }}</span
                >
                요일에
              </div>
              <div class="work-time">
                <input
                  type="number"
                  @input="setInputStartHour"
                  minlength="2"
                  min="00"
                  max="24"
                  v-model="inputValue.startHour"
                  :style="{ width: inputWidth.startHour + 5 + 'px' }"
                  placeholder="출근시간"
                />시 부터
                <input
                  type="number"
                  @input="setInputEndHour"
                  minlength="2"
                  min="00"
                  max="24"
                  v-model="inputValue.endHour"
                  :style="{ width: inputWidth.endHour + 5 + 'px' }"
                  placeholder="퇴근시간"
                />시 까지 일한다.
              </div>
            </div>
          </div>
          <!-- width 확인용 div -->
          <div class="size-wrap">
            <div class="date-size" ref="dateSize">
              {{ inputValue.date.length === 0 ? "급여일" : inputValue.date }}
            </div>
            <br />
            <div class="pay-size" ref="paySize">
              {{
                inputValue.pay.length === 0 ? "월급 실수령액" : inputValue.pay
              }}
            </div>
            <br />
            <div class="time-size" ref="startHourSize">
              {{
                inputValue.startHour.length === 0
                  ? "출근시간"
                  : inputValue.startHour
              }}
            </div>
            <br />
            <div class="time-size" ref="endHourSize">
              {{
                inputValue.endHour.length === 0
                  ? "퇴근시간"
                  : inputValue.endHour
              }}
            </div>
            <br />
          </div>
        </div>
        <div class="nav-wrap bottom" v-show="!isFullPageMoving">
          <div class="nav gray" v-if="isDataTrue"></div>
        </div>
        <div class="nav-wrap top" v-show="!isFullPageMoving">
          <div class="nav gray"></div>
        </div>
      </div>
      <!-- <div class="section ad">
        <div class="section-content center">
          <div class="ad-img" @click="adClick">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/selleryapp.appspot.com/o/apple.png?alt=media&token=1c840535-b75a-41cc-aa55-e55ab77c91ed"
              alt
            >
          </div>
        </div>
        <div class="nav-wrap bottom" v-show="!isFullPageMoving">
          <div class="nav gray" v-if="isDataTrue"></div>
        </div>
        <div class="nav-wrap top" v-show="!isFullPageMoving">
          <div class="nav gray"></div>
        </div> -->
      <!-- </div> -->
      <div class="section s4">
        <div class="section-content percent">
          <div class="input-wrap">
            <div class="day-text" ref="dayText">
              오늘 출근해서,
              <br />
              <CountUp
                class="number"
                :startVal="0"
                :endVal="currentPage === 2 ? todayPay : 0"
                :decimals="countOption.decimals"
                :duration="countOption.duration"
                :options="countOption.options"
              />원 벌었다.
            </div>
            <div class="carousel-wrap web">
              <carousel
                v-if="todayPay !== 0"
                :loop="true"
                :perPage="1"
                :paginationEnabled="false"
                :navigationEnabled="true"
                navigationPrevLabel="<button class='label prev'></button>"
                navigationNextLabel="<button class='label next'></button>"
                :autoplay="true"
                :autoplayTimeout="3000"
                :autoplayHoverPause="true"
              >
                <slide v-for="(data, i) in macData" :key="i">
                  <div class="mac">
                    {{ (todayPay / data.price).toFixed(2) }} {{ data.name }}
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
          <div class="msg-wrap">
            일급 게이지가 차고 있어요! 오늘도 힘내세요 :)
          </div>
          <percent-bar
            :val="currentPage === 2 ? percentData.day.toFixed(2) : 0"
            colorName="Green"
            :color="['#7FFF79', '#2BF389']"
          />
          <div class="carousel-wrap mobile">
            <vert-carousel
              :list="MacListForMobile"
              :fontSize="2"
              :lineHeight="1.5"
              :lineCount="3"
              :autoplayDelay="2000"
            ></vert-carousel>
          </div>
        </div>
        <div class="nav-wrap bottom" v-show="!isFullPageMoving">
          <div class="nav gray"></div>
        </div>
        <div class="nav-wrap top" v-show="!isFullPageMoving">
          <div class="nav gray"></div>
        </div>
      </div>
      <div class="section s5">
        <div class="section-content percent">
          <div class="input-wrap">
            <div class="month-text">
              이번 달도
              <br />
              <CountUp
                class="number"
                :startVal="0"
                :endVal="currentPage === 3 ? workedDatesPay : 0"
                :decimals="countOption.decimals"
                :duration="countOption.duration"
                :options="countOption.options"
              />원 버텼다.
            </div>
            <div class="carousel-wrap web">
              <carousel
                v-if="todayPay !== 0"
                :loop="true"
                :perPage="1"
                :paginationEnabled="false"
                :navigationEnabled="true"
                navigationPrevLabel="<button class='label prev'></button>"
                navigationNextLabel="<button class='label next'></button>"
                :autoplay="true"
                :autoplayTimeout="3000"
                :autoplayHoverPause="true"
              >
                <slide v-for="(data, i) in macData" :key="i">
                  <div class="mac">
                    {{ (workedDatesPay / data.price).toFixed(2) }}
                    {{ data.name }}
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
          <div class="msg-wrap">이번 달도 이만큼 버텼네요! 수고했어요 :3</div>
          <percent-bar
            :val="currentPage === 3 ? percentData.month.toFixed(2) : 0"
            colorName="Blue"
            :color="['#57B2FE', '#3521FF']"
          />
        </div>
        <div class="nav-wrap top" v-show="!isFullPageMoving">
          <div class="nav gray"></div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
import CountUp from "vue-countup-v2";
import { Carousel, Slide } from "vue-carousel";
import Slick from "vue-slick";

export default {
  components: { CountUp, Carousel, Slide, Slick },
  data() {
    return {
      notiDate: "2009-02-11",
      showNoti: false,
      isMore: false,
      isFullPageMoving: false,
      isPayLastDay: false, // 말일이 월급날인가요?
      weekdayNameList: ["일", "월", "화", "수", "목", "금", "토"],
      incSecond: 0,
      inputValue: {
        // 필수 정보
        date: "", // 급여일
        pay: "", // 급여(세후)
        startHour: 9, // 출근시간
        endHour: 18 // 퇴근시간
      },
      today: {
        year: new Date().getFullYear(), // 오늘 연도
        month: new Date().getMonth() + 1, // 오늘 월
        date: new Date().getDate(), // 오늘 날짜
        day: new Date().getDay() // 오늘 요일
      },
      fullpageOpt: {
        licenseKey: "AECEE174-03C44664-903D3288-9CDA6883",
        afterLoad: this.afterLoad,
        onLeave: this.onLeave,
        scrollOverflow: false
      },
      worksDays: [1, 2, 3, 4, 5],
      todayPercent: 0,
      monthPercent: 0,
      inputWidth: {
        date: 0,
        pay: 0,
        startHour: 0,
        endHour: 0
      },
      countOption: {
        decimals: 0,
        duration: 0.5,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ",",
          decimal: "."
        }
      },
      macData: [
        { id: 1, name: "치킨", price: 20000 },
        { id: 2, name: "담배", price: 5000 },
        { id: 3, name: "아이스 아메리카노 ", price: 4500 }
      ]
    };
  },
  created() {
    // this.checkNoti()
    this.redirect();
    this.incSec();
    if (this.$session.exists()) {
      const sessionData = this.$session.get("inputData");
      this.inputValue = sessionData.inputValue;
      this.worksDays = sessionData.worksDays;
    }
    this.init();

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      this.$nextTick(() => {
        // 아이폰일 때
        document.querySelectorAll(".fp-tableCell").forEach(el => {
          el.children[0].style.height = window.innerHeight + "px";
        });
        document
          .querySelectorAll(".percent-wrap .vert .percent-default")
          .forEach(el => {
            el.children[0].style.height = window.innerHeight + "px";
          });
      });
    }
  },
  methods: {
    redirect() {
      if (document.location.host === "selleryapp.firebaseapp.com") {
        location.href = "https://sellery.me";
      }
    },
    adClick() {
      gtag("event", "광고 클릭", {
        event_category: "광고 클릭",
        event_label: "A-Lounge"
      });
      window.open("http://www.tmon.co.kr/deal/1984542450");
    },
    checkNoti() {
      if (localStorage.checkNoti >= this.notiDate) {
        console.log("<");
      } else {
        console.log(">");
        this.showNoti = true;
      }
    },
    closeNoti() {
      this.showNoti = false;
      localStorage.checkNoti = new Date().toISOString().slice(0, 10);
    },
    init() {
      this.$nextTick(() => {
        this.setInputDate();
        this.setInputPay();
        this.setInputStartHour();
        this.setInputEndHour();
      });
    },
    dayClicked(e) {
      const day = Number(e.currentTarget.getAttribute("day-val"));
      // console.log('day', day)
      const i = this.worksDays.indexOf(day);
      // console.log('i', i)
      if (i > -1) {
        if (this.worksDays.length > 1) {
          this.worksDays.splice(i, 1);
        }
      } else {
        this.worksDays.push(day);
      }
    },
    inputRefresh() {
      this.inputWidth.date = this.$refs.dateSize.clientWidth;
      this.inputWidth.pay = this.$refs.paySize.clientWidth;
      this.inputWidth.startHour = this.$refs.startHourSize.clientWidth;
      this.inputWidth.endHour = this.$refs.endHourSize.clientWidth;
    },
    incSec() {
      setInterval(() => {
        const tmp = new Date(
          this.today.year,
          this.today.month - 1,
          this.today.date,
          this.inputValue.startHour,
          (this.inputValue.startHour % 1) * 60
        );
        if (new Date().valueOf() - tmp.valueOf() > 0) {
          this.incSecond = (new Date().valueOf() - tmp.valueOf()) / 1000;
        } else {
          this.incSecond = 0;
        }
      }, 1000);
    },
    setInputDate(e) {
      if (this.inputValue.date.length === 0) {
        this.$nextTick(() => {
          this.inputWidth.date = this.$refs.dateSize.clientWidth;
        });
      } else {
        let date = 0;
        if (e) {
          date = Number(e.currentTarget.value);
        } else {
          date = Number(this.$refs.dateSize.value);
        }
        if (date > 31) {
          this.inputValue.date = "31";
        } else if (date < 1) {
          this.inputValue.date = "1";
        }
        this.$nextTick(() => {
          this.inputWidth.date = this.$refs.dateSize.clientWidth;
        });
      }
    },
    setInputPay(e) {
      if (e && e.target) {
        function getNumber(val) {
          const num = val.replace(/\D/g, ""); //숫자가 아닌것을 제거, 즉 [0-9]를 제외한 문자 제거; /[^0-9]/g 와 같은 표현
          return setComma(num); //콤마 찍기
        }
        function setComma(n) {
          var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
          n += ""; // 숫자를 문자열로 변환
          while (reg.test(n)) {
            n = n.replace(reg, "$1" + "," + "$2");
          }
          return n;
        }
        const value = setComma(getNumber(e.target.value));
        this.inputValue.pay = value;
        this.$nextTick(() => {
          this.inputWidth.pay = this.$refs.paySize.clientWidth;
        });
      }
    },
    setInputStartHour(e) {
      if (this.inputValue.startHour.length === 0) {
        this.$nextTick(() => {
          this.inputWidth.startHour = this.$refs.startHourSize.clientWidth;
        });
      } else {
        if (e) {
          let val = Number(e.currentTarget.value);
          if (val > 24) {
            this.inputValue.startHour = "24";
          } else if (val < 0) {
            this.inputValue.startHour = "0";
          }
        }
        this.$nextTick(() => {
          this.inputWidth.startHour = this.$refs.startHourSize.clientWidth;
        });
      }
    },
    setInputEndHour(e) {
      if (this.inputValue.endHour.length === 0) {
        this.$nextTick(() => {
          this.inputWidth.endHour = this.$refs.endHourSize.clientWidth;
        });
      } else {
        if (e) {
          let val = Number(e.currentTarget.value);
          if (val > 24) {
            this.inputValue.endHour = "24";
          } else if (val < 0) {
            this.inputValue.endHour = "0";
          }
        }
        this.$nextTick(() => {
          this.inputWidth.endHour = this.$refs.endHourSize.clientWidth;
        });
      }
    },
    afterLoad(before, after) {
      this.$store.commit("changeIndex", after.index);
      this.isFullPageMoving = false;

      if (before && before.index === 2) {
        this.$session.set("inputData", {
          inputValue: this.inputValue,
          worksDays: this.worksDays
        });
      }
    },
    onLeave(before, after, direction) {
      this.isFullPageMoving = true;
      if (after.index === 1) {
        this.inputRefresh();
      }
      if (before.index === 1 && direction === "down" && !this.isDataTrue) {
        this.isFullPageMoving = false;
        return false;
      }
    },
    // 날짜 계산
    fmtDate(d) {
      return new Date(
        d.substr(0, 4),
        Number(d.substr(4, 2)) - 1,
        Number(d.substr(6))
      );
    },
    lcDateCountDay(d1, d2) {
      var count = 0;
      var tmp;
      for (var i = 0; i <= (d2 - d1) / 1000 / 60 / 60 / 24; i++) {
        tmp = new Date(d1);
        tmp.setDate(tmp.getDate() + i);
        if (this.worksDays.indexOf(tmp.getDay()) >= 0) {
          count++;
        }
      }
      return count;
    }
  },
  computed: {
    maxDate() {
      return new Date(this.today.year, this.today.month, 0).getDate();
    },
    MacListForMobile() {
      const result = [];
      this.macData.forEach(m => {
        const tmp = (this.todayPay / m.price).toFixed(2) + " " + m.name;
        result.push(tmp);
      });
      return result;
    },
    isTodayWeekday() {
      return this.worksDays.indexOf(this.today.day) > -1;
    },
    isDataTrue() {
      return String(this.percentData.day) !== "NaN";
    },
    currentPage() {
      return this.$store.getters.getSlideIndex;
    },
    isAfterPay() {
      // 이번달에 월급을 받았나요?
      const inputVal = Number(this.inputValue.date);
      if (inputVal === 1) {
        return true;
      }
      return inputVal < this.today.date;
    },
    beforePayDay() {
      // 이전 월급일
      if (!this.isAfterPay) {
        if (this.today.month === 1) {
          return (
            "" +
            (this.today.year - 1) +
            "12" +
            ("0" + this.inputValue.date).slice(-2)
          );
        } else {
          return (
            "" +
            this.today.year +
            ("0" + (this.today.month - 1)).slice(-2) +
            ("0" + this.inputValue.date).slice(-2)
          );
        }
      } else {
        return (
          "" +
          this.today.year +
          ("0" + this.today.month).slice(-2) +
          ("0" + this.inputValue.date).slice(-2)
        );
      }
    },
    nextPayDay() {
      // 다음 월급일
      if (this.isAfterPay) {
        // 월급날이 지났고
        if (this.today.month === 12) {
          // 12월 일때
          // 연도에 1 더하고, 날짜 구함
          return (
            "" +
            (this.today.year + 1) +
            "01" +
            ("0" + this.inputValue.date).slice(-2)
          );
        } else {
          //12월이 아닐 때
          return (
            "" +
            this.today.year +
            ("0" + (this.today.month + 1)).slice(-2) +
            ("0" + this.inputValue.date).slice(-2)
          );
        }
      } else {
        return (
          "" +
          this.today.year +
          ("0" + this.today.month).slice(-2) +
          ("0" + this.inputValue.date).slice(-2)
        );
      }
    },
    today8Num() {
      // 오늘 날짜 YYYYMMDD
      return (
        "" +
        this.today.year +
        ("0" + this.today.month).slice(-2) +
        ("0" + this.today.date).slice(-2)
      );
    },
    thisMonthWeekDays() {
      // 이번 기간 전체 평일 수
      return this.lcDateCountDay(
        this.fmtDate(this.beforePayDay),
        this.fmtDate(this.nextPayDay)
      );
    },
    thisMonthWorkedDays() {
      const tmp = this.lcDateCountDay(
        this.fmtDate(this.beforePayDay),
        this.fmtDate(this.today8Num)
      );
      return this.isTodayWeekday ? tmp - 1 : tmp;
    },
    payPerDay() {
      return (
        Number(this.inputValue.pay.replace(/\D/g, "")) / this.thisMonthWeekDays
      );
    },
    payPerSecond() {
      return (
        this.payPerDay /
        ((Number(this.inputValue.endHour) - Number(this.inputValue.startHour)) *
          3600)
      );
    },
    payPerSecond_() {
      return (
        (Number(this.inputValue.endHour) - Number(this.inputValue.startHour)) *
        60 *
        60
      );
    },
    todayPay() {
      let tmp = Math.floor(this.payPerSecond * this.incSecond);
      return this.isTodayWeekday
        ? tmp > this.payPerDay
          ? this.payPerDay
          : tmp
        : 0;
    },
    workedDatesPay() {
      return Math.floor(
        this.todayPay + this.payPerDay * this.thisMonthWorkedDays
      );
    },
    percentData() {
      // todo
      return {
        day: (this.todayPay / this.payPerDay) * 100,
        month:
          (this.workedDatesPay /
            Number(this.inputValue.pay.replace(/\D/g, ""))) *
          100
      };
    }
  }
};
</script>

<style>
.section {
  display: table;
  width: 100vw;
  height: 100% !important;
  position: relative;
}
.section .section-content {
  display: table-cell;
  width: 100vw;
  height: 100vh;
  vertical-align: middle;
  background-image: inherit;
  position: relative;
  overflow: hidden;
}

.section .section-content p a {
  color: #2bd369;
  text-decoration: none;
}

.section .section-content p a.close {
  color: #2bd369;
  font-weight: 600;
  font-size: 0.8rem;
}

/* .section .section-content .blur { position: absolute; bottom: -35vw; width: 100vw; height: 50vw; background: inherit; border-top-right-radius: 50vw; border-top-left-radius: 50vw; overflow: hidden; }
.section .section-content .blur:after { content: ''; display: block; width: 100%; height: 100%; background: inherit; filter: blur(15px); margin: -100px; }
.section .section-content .blur-dim { position: absolute; bottom: -35vw; width: 100vw; height: 50vw; background: rgba(255, 255, 255, .1); border-top-right-radius: 50vw; border-top-left-radius: 50vw; overflow: hidden; z-index: 1; }
.section .section-content .blur-dim .logo { width: 21.8vw; margin-top: 2.38vw; } */

.section .nav-wrap {
  width: 100vw;
  position: absolute;
  text-align: center;
}
.section .nav-wrap.bottom {
  bottom: 20px;
}
.section .nav-wrap.top {
  top: 20px;
}
.section .nav-wrap .nav {
  width: 22.3px;
  height: 12.3px;
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  background-image: url("../assets/nav-white.svg");
}
.section .nav-wrap .nav.gray {
  background-image: url("../assets/nav-darkgrey.svg");
  opacity: 0.3;
}
.section .nav-wrap.top .nav {
  transform: rotate(180deg);
}

.section.s2 .section-content .logo {
  width: 20.9rem;
  margin-bottom: 10vh;
}

.section .section-content .input-wrap {
  font-size: 60px;
  line-height: 93px;
  font-weight: 300;
  text-align: left;
  margin: 0 auto;
  display: inline-block;
  letter-spacing: -1.4px;
  color: #3e3e3e;
}
.section .section-content .input-wrap input {
  font-size: 60px;
  line-height: 93px;
  height: 62px;
  font-weight: 400;
  display: inline-block;
  letter-spacing: -1.4px;
  color: #3e3e3e;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-progress-appearance: none;
  border: 0;
  border-bottom: 1px solid #333333;
  transition: all 0.1s ease-in-out;
  overflow: visible;
  text-align: center;
}
.section .section-content .input-wrap input::-ms-clear {
  display: none;
}
.section .section-content .input-wrap input::-webkit-outer-spin-button,
.section .section-content .input-wrap input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.section .section-content .input-wrap input[type="number"] {
  -moz-appearance: textfield;
}
.section .section-content .msg-wrap {
  width: 80%;
  margin: auto;
  text-align: left;
  font-size: 22px;
  font-weight: 100;
  line-height: 1.23;
  color: #0a0a0a;
  margin-top: 100px;
}

.section .section-content .input-wrap .more-data {
  font-size: 60px;
  line-height: 93px;
  font-weight: 300;
  text-align: left;
  display: block;
  letter-spacing: -1.4px;
  color: #3e3e3e;
  text-align: left;
  overflow-y: hidden;
  transition: all 0.3s;
  height: 0;
}
.section .section-content .input-wrap .more-data.open {
  height: 186px;
}

.section .section-content .input-wrap .more-data input {
  font-size: 60px;
  line-height: 93px;
  border: solid 1px #d3d3d3;
}

button.more {
  width: 30px;
  height: 30px;
  background: url("../assets/plus.svg") center no-repeat;
  background-size: cover;
  border: 0;
  padding: 0;
  margin-left: 98px;
}
button.more.minus {
  background-image: url("../assets/minus.svg");
}

.size-wrap {
  width: 100%;
  display: block;
  width: 0;
  height: 0;
}
.date-size,
.pay-size {
  display: inline-block;
  height: 0;
  font-size: 60px;
  line-height: 93px;
  font-weight: 400;
  overflow: hidden;
  letter-spacing: -1.4px;
  white-space: nowrap;
}
.time-size {
  display: inline-block;
  height: 0;
  font-size: 60px;
  line-height: 93px;
  font-weight: 400;
  overflow: hidden;
  letter-spacing: -1.4px;
}

.work-day > span {
  opacity: 0.3;
  font-weight: 600;
}
.work-day > span.active {
  opacity: 1;
}

.mac {
  width: 100%;
  font-size: 30px;
  text-align: center;
}
.VueCarousel {
  margin-top: 3vh;
}

.carousel-wrap.web {
  display: inline-block;
}
.carousel-wrap.mobile {
  display: none;
}

button.label {
  width: 49px;
  height: 49px;
  background: transparent;
  transition: all 0.3s;
  border: 0;
  border-radius: 50%;
  background: transparent url("../assets/carouselNext.svg") center no-repeat;
  background-size: 30%;
}
button.label:hover {
  background-color: #f7f7f7;
}
button.label.next {
}
button.label.prev {
  transform: rotate(180deg);
}

/* ad */

.ad-img {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  position: relative;
}

.ad-img:after {
  position: absolute;
  left: 0.6rem;
  top: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 1rem;
  color: #ccc;
  padding: 0.1rem 0.5rem;
  font-size: 10px;
  content: "AD";
}

.ad-img img {
  width: 100%;
}

@media screen and (max-width: 640px) {
  html {
    font-size: 18px;
    line-height: 1.2;
  }
  .section {
    position: relative;
    overflow: hidden;
  }
  .section .section-content {
    text-align: left;
    box-sizing: border-box;
    width: 100vw;
    max-width: 100vw;
  }

  .section .section-content.percent {
    padding-left: 8vw;
    padding-right: 40vw;
  }

  .section.s1 .section-content,
  .section.s2 .section-content {
    padding: 0;
    box-sizing: content-box;
    text-align: center;
  }
  .section.s2 .section-content .logo {
    width: 70vw;
    margin-bottom: 0;
  }

  .section .section-content .blur {
    display: none;
  }
  .section .section-content .blur:after {
    margin: 0;
  }
  .section .section-content .blur-dim {
    left: -10vw;
    bottom: -20vw;
    width: 120vw;
    height: 60vw;
    background: rgba(255, 255, 255, 0.2);
    border-top-right-radius: 60vw;
    border-top-left-radius: 60vw;
    overflow: hidden;
    z-index: 1;
  }
  .section .section-content .blur-dim .logo {
    width: 40vw;
    margin-top: 4vh;
  }

  .section .section-content .input-wrap {
    width: 52vw;
    font-size: 4rem;
    line-height: 1.2;
  }
  .section .section-content .input-wrap.center {
    display: block;
    margin: 0 auto;
  }
  .section .section-content .input-wrap input {
    font-size: 4rem;
    height: 3.8rem;
    padding: 0;
    line-height: 1.2;
  }

  button.more {
    width: 2rem;
    height: 2rem;
    margin-left: 1rem;
  }

  .date-size,
  .pay-size {
    font-size: 4rem;
    line-height: 1.2;
  }
  .time-size {
    font-size: 3rem;
    line-height: 1.2;
  }
  .section .section-content .input-wrap .more-data {
    font-size: 3rem;
    line-height: 1.2;
    height: 0;
  }
  .section .section-content .input-wrap .more-data.open {
    height: 18rem;
  }
  .section .section-content .input-wrap .more-data input {
    font-size: 3rem;
    height: 2.8rem;
    line-height: 1.2;
  }

  .section .section-content .msg-wrap {
    width: 100%;
    font-size: 1.3rem;
    white-space: nowrap;
    margin-top: 1rem;
    margin-bottom: 8rem;
  }

  .carousel-wrap.web {
    display: none;
  }
  .carousel-wrap.mobile {
    display: inline-block;
    overflow-x: hidden;
    overflow-x: visible;
    overflow-y: visible;
  }

  /* ad */

  .ad-img {
    display: block;
    width: 90%;
    margin: 0 auto;
  }

  .ad-img:after {
    font-size: 0.9rem;
  }
}

@media screen and (max-width: 608px) {
  html {
    font-size: 17px;
  }
}
@media screen and (max-width: 576px) {
  html {
    font-size: 16px;
  }
}
@media screen and (max-width: 544px) {
  html {
    font-size: 15px;
  }
}
@media screen and (max-width: 512px) {
  html {
    font-size: 14px;
  }
}
@media screen and (max-width: 480px) {
  html {
    font-size: 13px;
  }
}
@media screen and (max-width: 448px) {
  html {
    font-size: 12px;
  }
}
@media screen and (max-width: 416px) {
  html {
    font-size: 11px;
  }
}
@media screen and (max-width: 384px) {
  html {
    font-size: 10px;
  }
}
@media screen and (max-width: 352px) {
  html {
    font-size: 9px;
  }
}
@media screen and (max-width: 320px) {
  html {
    font-size: 8px;
  }
}
</style>
